import Head from 'next/head';
import { useRouter } from 'next/router';
import { ReactElement, useEffect } from 'react';

import { ONBOARDING_FLOW_STATE } from 'lib/consts/flowState';
import { PAGE_ROUTES } from 'lib/page-routes';
import { useAuth } from 'lib/providers/AuthProvider';
import { fetchTranslationFiles, LOCALE_PAGES } from 'lib/services/page';

import styles from '../Recruiter.module.scss';
import SuccessScreen from './SuccessScreen';

const SignUp = (): ReactElement => {
  const router = useRouter();
  const { recruiter } = useAuth();

  useEffect(() => {
    if (recruiter?.flow_state !== ONBOARDING_FLOW_STATE.PRE_COMPLETE) {
      router.push(PAGE_ROUTES.RECRUITER_SIGN_UP);
    }
  }, []);

  return (
    <>
      <Head>
        <title>Recruiter Sign Up | Huzzle</title>
        <meta name="description" content="Sign up to Huzzle as a Recruiter." />
      </Head>
      <section className={styles.container} data-testid="Signin">
        <SuccessScreen />
      </section>
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await fetchTranslationFiles({
        locale,
        pages: [LOCALE_PAGES.SIGNUP_RECRUITER_SUCCESS],
      })),
    },
  };
}
export default SignUp;
